import { useEffect, useState } from "react";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { timestamp } from "../../firebase-config/config";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { useLocation } from "react-router-dom";
import { projectFirestore, projectStorage } from "../../firebase-config/config";
import {
  MDBCard,
  MDBCardBody,
  MDBRow,
  MDBCol,
  MDBCardText,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { FaEdit, FaHeart } from "react-icons/fa";
import ReactSwitch from "react-switch";
import Gallery from "react-image-gallery";
import Popup from "../../default-components/Popup";
import TextEditor from "../../default-components/TextEditor";
const PGEvents = () => {
  // Scroll to the top of the page whenever the location changes start
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Start firebase code
  const { user } = useAuthContext();
  const { addDocument, error } = useFirestore("events");
  const { documents: eventsDoc } = useCollection("events", null, ["order"]);
  const { updateDocument, deleteDocument } = useFirestore("events");

  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);

  const [checked, setChecked] = useState(); // Toggle button state
  const [expandedSection, setExpandedSection] = useState(null);
  const [editedEventsTitle, setEditedEventsTitle] = useState("");
  const [isEditingEventsTitle, setIsEditingEventsTitle] = useState(false);
  const [editedEventsDescription, setEditedEventsDescription] = useState("");
  const [isEditingJobDescription, setIsEditingJobDescription] = useState(false);

  const [selectedImage, setSelectedImage] = useState([]); // State to hold the selected image file
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [eventIdToDelete, setEventToDelete] = useState();
  const [isHeartClicked, setIsHeartClicked] = useState({});

  useEffect(() => {
    // Fetch document data and set edited values
    if (eventsDoc && eventsDoc.length > 0) {
      const firstEventDoc = eventsDoc[0];
      setEditedEventsTitle((firstEventDoc && firstEventDoc.Title) || "");
      setEditedEventsDescription(
        (firstEventDoc && firstEventDoc.Description) || ""
      );
    }
  }, [eventsDoc]);

  // CODE FOR ADD IMAGE IN GALLERY
  const handleImageChange = (event) => {
    const files = event.target.files; // Get the selected files
    const selectedImagesArray = Array.from(files); // Convert FileList to array
    setSelectedImage(selectedImagesArray); // Set the selected files to state
  };
  // Function to handle confirming the selected image
  const handleConfirmImage = async (productId) => {
    try {
      setIsImageUploading(true); // Set isImageUploading to true when uploading starts

      // Retrieve current EventsImages array from Firestore
      const doc = await projectFirestore
        .collection("events")
        .doc(productId)
        .get();
      const currentImages = doc.data().eventsImages || []; // Get current images or initialize as empty array

      // Upload the selected images to Firebase Storage and get their download URLs
      const downloadURLs = await Promise.all(
        selectedImage.map(async (image) => {
          // Upload image to Firebase Storage
          const storageRef = projectStorage.ref(
            `events_img/${productId}/${image.name}`
          );
          await storageRef.put(image);
          // Get download URL of the uploaded image
          return storageRef.getDownloadURL();
        })
      );

      // Concatenate the new URLs with the current images
      const updatedImages = [...currentImages, ...downloadURLs];

      // Update your document in Firestore with the updated eventsImages array
      await projectFirestore
        .collection("events")
        .doc(productId)
        .update({ eventsImages: updatedImages });

      // Reset selected images state
      setSelectedImage([]);
      setIsImageUploading(false); // Set isImageUploading to false when uploading finishes
    } catch (error) {
      console.error("Error adding images:", error);
      setIsImageUploading(false); // Ensure isImageUploading is set to false in case of error
    }
  };
  //END CODE FOR ADD IMAGE IN GALLERY

  // START CODE FOR EDIT FIELDS
  const handleEditClick = (fieldName) => {
    switch (fieldName) {
      case "eventstitle":
        setIsEditingEventsTitle(true);
        break;
      case "eventsdescription":
        setIsEditingJobDescription(true);
        break;
      default:
        break;
    }
  };

  const handleSaveClick = async (fieldName) => {
    try {
      switch (fieldName) {
        case "eventstitle":
          setIsEditingEventsTitle(false);
          break;
        case "eventsdescription":
          setIsEditingJobDescription(false);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Error updating field:", error);
    }
  };

  const handleCancelClick = (fieldName) => {
    switch (fieldName) {
      case "eventstitle":
        setIsEditingEventsTitle(false);
        break;
      case "eventsdescription":
        setIsEditingJobDescription(false);
        break;
      // Add more cases for other fields if needed
      default:
        break;
    }
  };
  // END CODE FOR EDIT FIELDS

  // START CODE FOR SHARE SERVICE
  const shareURL = async () => {
    try {
      await navigator.share({
        title: "Share this service",
        text: "Check out this service!",
        url: window.location.href,
      });
    } catch (error) {
      console.error("Sharing failed:", error);
    }
  };
  // END CODE FOR SHARE SERVICE

  // START CODE FOR CHANGE SERVICE STATUS
  const handleToggleChange = (productId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    // Update the status in Firestore
    projectFirestore
      .collection("events")
      .doc(productId)
      .update({ status: newStatus })
      .then(() => {
        console.log("Product status updated successfully");
        setChecked(newStatus === "active"); // Update the toggle state based on the new status
      })
      .catch((error) => {
        console.error("Error updating product status:", error);
      });
  };
  // END CODE FOR CHANGE SERVICE STATUS

  // START CODE FOR DELETE event DOC
  const handleDeleteeventsDoc = async (eventsId) => {
    try {
      // Open the delete confirmation popup
      setIsDeletePopupOpen(true);
      setEventToDelete(eventsId); // Set the eventsId to delete when the confirmation is received
    } catch (error) {
      console.error("Error deleting event:", error);
      // Handle the error as needed
    }
  };

  const handleConfirmDeleteProduct = async () => {
    try {
      // Call deleteDocument function with the eventsId to delete the document
      await deleteDocument(eventIdToDelete);
      setIsDeletePopupOpen(false); // Close the popup after successful deletion
      setEventToDelete(null); // Reset the eventIdToDelete after deletion
    } catch (error) {
      console.error("Error deleting event:", error);
      // Handle the error as needed
    }
  };
  // END CODE FOR DELETE event DOC

  // START CODE FOR DRAG SERVICES
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDrop = async (droppedIndex) => {
    try {
      if (draggedIndex !== droppedIndex) {
        const draggedService = eventsDoc[draggedIndex];
        const droppedService = eventsDoc[droppedIndex];
        const updatedServices = [...eventsDoc];
        updatedServices[droppedIndex] = draggedService;
        updatedServices[draggedIndex] = droppedService;
        await updateDocument(draggedService.id, { order: droppedIndex });
        await updateDocument(droppedService.id, { order: draggedIndex });
      }
    } catch (error) {
      console.error("Error updating document:", error);
    } finally {
      setDraggedIndex(null);
    }
  };

  const handleDrag = (e) => {
    const { clientY } = e;
    const viewportHeight = window.innerHeight;
    const threshold = 50; // Adjust this threshold as needed

    // Calculate distance from top and bottom edges of the viewport
    const distanceToTop = clientY;
    const distanceToBottom = viewportHeight - clientY;

    // Check if the item is close to the top edge
    if (distanceToTop < threshold) {
      // Scroll up
      window.scrollBy(0, -10); // Adjust scroll speed as needed
    } else if (distanceToBottom < threshold) {
      // Check if the item is close to the bottom edge
      // Scroll down
      window.scrollBy(0, 10); // Adjust scroll speed as needed
    }
  };
  // END CODE FOR DRAG SERVICES

  //START CODE FOR HEART CLICK AND STORE IN BROWSER STORAGE
  // Update toggleHeartStatus function
  const toggleHeartStatus = (eventsId) => {
    const newHeartStatus = !isHeartClicked[eventsId];
    setIsHeartClicked((prevState) => ({
      ...prevState,
      [eventsId]: newHeartStatus,
    }));
    localStorage.setItem(`heartStatus_${eventsId}`, newHeartStatus);
  };

  // Initialize heart status object in useEffect
  useEffect(() => {
    if (eventsDoc) {
      const initialHeartStatusFromLocalStorage = {};
      eventsDoc.forEach((events) => {
        const localStorageKey = `heartStatus_${events && events.id}`;
        const storedHeartStatus = localStorage.getItem(localStorageKey);
        if (storedHeartStatus !== null) {
          initialHeartStatusFromLocalStorage[events && events.id] =
            storedHeartStatus === "true";
        } else {
          // If no heart status is stored, default to false
          initialHeartStatusFromLocalStorage[events && events.id] = false;
        }
      });
      setIsHeartClicked(initialHeartStatusFromLocalStorage);
    }
  }, [eventsDoc]);

  //END CODE FOR HEART CLICK AND STORE IN BROWSER STORAGE

  // START CODE FOR EXPAND EVENTS CONTENT
  const toggleExpand = (section) => {
    if (expandedSection === section) {
      setExpandedSection(null);
    } else {
      setExpandedSection(section);
    }
  };
  // END CODE FOR EXPAND EVENTS CONTENT

  // ADD  NEW EVENT CODE START
  const addEvents = async () => {
    const newEvent = {
      Title: "",
      Description: "",
      order: 0,
      status: "active",
      createdAt: timestamp.fromDate(new Date()),
    };

    await addDocument(newEvent);

    window.scrollTo(0, 0);

    if (error) {
      console.log("New event not added");
    } else {
      console.log("New event added");
    }
  };
  // ADD  NEW EVENT CODE END

  return (
    <div>
      <div className="career-parent-div">
        <br />
        <div>
          <Popup
            showPopupFlag={isDeletePopupOpen}
            setShowPopupFlag={setIsDeletePopupOpen}
            msg="Are you sure you want to delete this events?"
            setPopupReturn={(confirmed) => {
              if (confirmed) {
                handleConfirmDeleteProduct();
              }
            }}
          />

          {eventsDoc &&
            eventsDoc.map((events, index) =>
              (user && user.role === "admin") ||
              (events && events.status === "active") ? (
                <div
                  className={`${draggedIndex === index ? "dragging" : ""}`}
                  draggable={user && user.role === "admin" && true}
                  onDragStart={() => handleDragStart(index)}
                  onDrag={(e) => handleDrag(e)}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={() => handleDrop(index)}
                  key={index}
                >
                  <div className="container">
                    {user && user.role === "admin" && (
                      <div
                        className="drag-button-container-only-faq"
                        style={{
                          position: "static",
                          transform: "none",
                          textAlign: "center",
                        }}
                      >
                        <span
                          class="material-symbols-outlined"
                          style={{
                            color: "var(--click-color)",
                            fontSize: "25px",
                            cursor: "grab",
                          }}
                          title=" "
                        >
                          apps
                        </span>
                        <span className="tooltip">
                          Drag and swap faq position
                        </span>
                      </div>
                    )}
                    <div className="career-section">
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-6">
                          <div className="pcs_image_area">
                            <div className="bigimage_container">
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  maxWidth: "600px",
                                }}
                              >
                                {events &&
                                  events.eventsImages &&
                                  events.eventsImages.length > 0 && (
                                    <Gallery
                                      items={events.eventsImages.map((url) => {
                                        // Extract the file extension
                                        const extension = url
                                          .split(".")
                                          .pop()
                                          .split("?")[0]
                                          .toLowerCase();
                                        if (
                                          extension == "mp4" ||
                                          extension === "webm" ||
                                          extension === "ogg"
                                        ) {
                                          // If it's a video
                                          return {
                                            original: url,
                                            thumbnail: "", // You might want to set a thumbnail for videos
                                            renderItem: () => (
                                              <video controls>
                                                <source
                                                  src="https://firebasestorage.googleapis.com/v0/b/cloudify-dev-84f4e.appspot.com/o/features_img%2FftH5wJuGARl37amdeVPC%2Fbig_buck_bunny_720p_1mb.mp4?alt=media&token=2ce0d2a4-3805-44d1-aa48-07220561bacb"
                                                  type={`video/${extension}`}
                                                />
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                            ),
                                          };
                                        } else {
                                          // If it's an image
                                          return {
                                            original: url,
                                            thumbnail: url,
                                          };
                                        }
                                      })}
                                      slideDuration={1000}
                                    />
                                  )}
                              </div>
                              {/* Box for adding more images */}
                              {user && user.role == "admin" && (
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ margin: "15px 0px" }}
                                >
                                  {selectedImage == 0 && (
                                    <>
                                      <button
                                        className="btn_fill"
                                        onClick={() =>
                                          document
                                            .getElementById("mediaUpload")
                                            .click()
                                        }
                                      >
                                        Add More
                                      </button>
                                      <input
                                        type="file"
                                        id="mediaUpload"
                                        accept="image/*,video/*" // Allow selecting both images and videos
                                        multiple // Allow selecting multiple files
                                        style={{ display: "none" }}
                                        onChange={handleImageChange} // Call handleMediaChange function when files are selected
                                      />
                                    </>
                                  )}

                                  {selectedImage != 0 && (
                                    <>
                                      {selectedImage.length !== 0 ? (
                                        <>
                                          <button
                                            className="btn_fill"
                                            onClick={() =>
                                              handleConfirmImage(events.id)
                                            }
                                            disabled={isImageUploading} // Disable the button when uploading
                                          >
                                            {isImageUploading
                                              ? "Uploading..."
                                              : "Confirm"}
                                          </button>
                                        </>
                                      ) : (
                                        <button disabled className="btn_fill">
                                          Uploading...
                                        </button>
                                      )}
                                    </>
                                  )}

                                  {/* Render selected images */}
                                  {selectedImage.map((image, index) => (
                                    <img
                                      key={index}
                                      src={URL.createObjectURL(image)}
                                      alt={`Selected ${index + 1}`}
                                      style={{
                                        marginLeft: "10px",
                                        maxWidth: "100px",
                                      }}
                                    />
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 services_details_right_dv">
                          <MDBCard className="mb-4">
                            <MDBCardBody style={{ textAlign: "left" }}>
                              <MDBRow>
                                <MDBCol sm="12">
                                  <MDBCardText style={{ fontWeight: "bold" }}>
                                    Title:
                                  </MDBCardText>
                                </MDBCol>
                                <MDBCol sm="12">
                                  <MDBCardText className="text-muted">
                                    {isEditingEventsTitle ? (
                                      <div>
                                        <TextEditor
                                          initialDescription={editedEventsTitle}
                                          documentId={events.id}
                                          docFieldName="Title"
                                          collectionName="events"
                                          onSave={() =>
                                            handleSaveClick("eventstitle")
                                          }
                                          onCancel={() =>
                                            handleCancelClick("eventstitle")
                                          }
                                        />
                                        {/* <input
                                      type="text"
                                      value={editedeventsTitle}
                                      onChange={(e) =>
                                        setEditedeventsTitle(e.target.value)
                                      }
                                    />
                                    <div className="d-flex">
                                      <button
                                        className="product_edit_save_btn"
                                        onClick={() =>
                                          handleSaveClick(
                                            "eventstitle",
                                            events.id
                                          )
                                        }
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="product_edit_save_btn cancel-btn"
                                        onClick={() =>
                                          handleCancelClick("eventstitle")
                                        }
                                        style={{ marginLeft: "10px" }}
                                      >
                                        Cancel
                                      </button>
                                    </div> */}
                                      </div>
                                    ) : (
                                      <>
                                        {/* {events && events.Title} */}
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              events.Title.toString("html"),
                                          }}
                                        ></p>
                                        {!isEditingEventsTitle &&
                                          user &&
                                          user.role == "admin" && (
                                            <FaEdit
                                              style={{
                                                fontSize: 20,
                                                cursor: "pointer",
                                                marginLeft: "10px",
                                                color: "var(--pink)",
                                              }}
                                              onClick={() =>
                                                handleEditClick("eventstitle")
                                              }
                                            />
                                          )}
                                      </>
                                    )}
                                  </MDBCardText>
                                </MDBCol>
                              </MDBRow>
                              <hr />
                              <MDBRow
                                onClick={() =>
                                  toggleExpand("eventsdescription")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <MDBCol
                                  sm="12"
                                  className="d-flex align-items-center justify-content-between"
                                >
                                  <div>
                                    <MDBCardText style={{ fontWeight: "bold" }}>
                                      Description:
                                    </MDBCardText>
                                  </div>
                                  <div>
                                    <span
                                      class="material-symbols-outlined"
                                      style={{
                                        fontSize: "1.6rem",
                                        color: "black",
                                      }}
                                    >
                                      arrow_drop_down
                                    </span>
                                  </div>
                                </MDBCol>
                                <MDBCol sm="12">
                                  <MDBCardText className="text-muted">
                                    {isEditingJobDescription ? (
                                      <div>
                                        <div>
                                          {/* <textarea
                                        value={editedEventsDescription}
                                        onChange={(e) =>
                                          setEditedEventsDescription(
                                            e.target.value
                                          )
                                        }
                                      /> */}
                                          <TextEditor
                                            initialDescription={
                                              editedEventsDescription
                                            }
                                            documentId={events.id}
                                            docFieldName="Description"
                                            collectionName="events"
                                            onSave={() =>
                                              handleSaveClick(
                                                "eventsdescription"
                                              )
                                            }
                                            onCancel={() =>
                                              handleCancelClick(
                                                "eventsdescription"
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <div>
                                        <p
                                          style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace:
                                              expandedSection ===
                                              "eventsdescription"
                                                ? "normal"
                                                : "nowrap",
                                          }}
                                        >
                                          {/* {events && events.Description} */}
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                events &&
                                                events.Description.toString(
                                                  "html"
                                                ),
                                            }}
                                          ></p>
                                          {!isEditingJobDescription &&
                                            user &&
                                            user.role == "admin" && (
                                              <FaEdit
                                                style={{
                                                  fontSize: 20,
                                                  cursor: "pointer",
                                                  marginLeft: "10px",
                                                  color: "var(--pink)",
                                                }}
                                                onClick={() =>
                                                  handleEditClick(
                                                    "eventsdescription"
                                                  )
                                                }
                                              />
                                            )}
                                        </p>
                                      </div>
                                    )}
                                  </MDBCardText>
                                </MDBCol>
                              </MDBRow>

                              {user && user.role == "admin" && (
                                <>
                                  <hr />
                                  <MDBRow>
                                    <MDBCol sm="3">
                                      <MDBCardText
                                        style={{ fontWeight: "bold" }}
                                      >
                                        Status:
                                      </MDBCardText>
                                    </MDBCol>
                                    <MDBCol sm="12">
                                      <MDBCardText className="text-muted">
                                        <div className="d-flex">
                                          <div>
                                            <p style={{ marginTop: "2px" }}>
                                              Inactive
                                            </p>
                                          </div>
                                          <ReactSwitch
                                            checked={
                                              events &&
                                              events &&
                                              events.status === "active"
                                            }
                                            onChange={() =>
                                              handleToggleChange(
                                                events && events.id,
                                                events && events.status
                                              )
                                            }
                                            onColor="#149AA2"
                                            offColor="#F05B83"
                                            className="products-status-switch"
                                          />
                                          <div>
                                            <p style={{ marginTop: "2px" }}>
                                              Active
                                            </p>
                                          </div>
                                        </div>
                                      </MDBCardText>
                                    </MDBCol>
                                  </MDBRow>
                                </>
                              )}
                            </MDBCardBody>
                          </MDBCard>
                          <div className="d-flex align-items-center namesd">
                            <MDBCol className="d-flex align-items-center">
                              <MDBCardText style={{ cursor: "pointer" }}>
                                <span
                                  className="material-symbols-outlined"
                                  onClick={shareURL}
                                  style={{
                                    fontSize: "23px",
                                    padding: "6px 0px",
                                  }}
                                >
                                  share
                                </span>
                              </MDBCardText>

                              {user && user.role == "admin" && (
                                <MDBCardText
                                  onClick={() =>
                                    handleDeleteeventsDoc(events.id)
                                  }
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{
                                      fontSize: "23px",
                                      padding: "6px 0px",
                                    }}
                                  >
                                    delete
                                  </span>
                                </MDBCardText>
                              )}

                              <FaHeart
                                style={{
                                  fontSize: 20,
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                  color: isHeartClicked[events && events.id]
                                    ? "red"
                                    : "grey",
                                }}
                                onClick={() =>
                                  toggleHeartStatus(events && events.id)
                                }
                              />
                            </MDBCol>

                            <div className="more-div-big-icon-div-inner pointer">
                              <Link to="/contact">
                                <button type="submit" className="btn_fill">
                                  Apply
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br /> <br /> <br />
                </div>
              ) : null
            )}
        </div>
        {user && user.role === "admin" && (
          <div className="d-flex justify-content-center align-items-center mb-5">
            <button className="btn_fill" onClick={addEvents}>
              Add Events
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PGEvents;
